import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ONBOARDING_ROUTES } from '../../../stores/session-status';
import TellyChannelLogo from '../../../images/app-store-icon.png';
import * as SessionActions from '../../../stores/actions/session';
import { GreenroomState as GS } from '../../../stores/types/types';
import LoadingSpinner from '../../general-components/loading-spinner';
import Colors from '../../../utils/colors';

export default function ProducerSelectApp() {
	const loadingProducerApps = useSelector((s: GS) => s.SessionReducer.loadingProducerApps);
	const loadingIsEventsProducer = useSelector((s: GS) => s.SessionReducer.loadingIsEventsProducer);

	const dispatch = useDispatch();

	function backButtonClicked() {
		dispatch(SessionActions.setOnboardingRoute(ONBOARDING_ROUTES.PRODUCER_ENTER_EMAIL));
	}

	return (
		<div className="panel producer sign-in select-app">
			<div className="producer-logo-title">
				<img src={TellyChannelLogo} style={{ width: '48px', marginBottom: '15px' }} alt={'Connected'} />
				<div className="title-container">
					<span className="title green">Greenroom	<span className="title">Producer</span></span>
				</div>
			</div>

			{(loadingProducerApps || loadingIsEventsProducer)
				? <div className="loading-container">
					<LoadingSpinner
						height={100}
						width={100}
						color={Colors.red}
					/>
				</div>
				: <div className="apps-container">
					
				</div>
			}
			<div className="back-button">
				<span><span onClick={backButtonClicked} className="clickable">Back to enter email</span></span>
			</div>
		</div>

	);
}
